'use client'

import React, { useContext } from "react";

import * as S from './HeroNews.styles';

import { Paragraph, Heading } from "../../../atoms/Typography/Typography.component";
import { SpacerBase, Container, Row, Col } from "../../../atoms/GridSystem";

import Image from "next/image";
import { format } from "date-fns";
import { it, enGB } from "date-fns/locale";
import { getPageLocale } from "@caffeina-siad/utils";
import { SectionThemeContext } from '../../../../contexts/SectionTheme.context'

const HeroNews = ({ date, tags, title, description, image, imageShape, withBackground }) => {
  const { selectedColorScheme } = useContext(SectionThemeContext)
  const pageLocale = getPageLocale();  
  const dateFnsLocale = {
    'it': it,
    'en': enGB
  }
  const locale = dateFnsLocale[pageLocale]

  return (

    <S.HeroNews withBackground={withBackground} colorScheme={selectedColorScheme}>
      <Container>
        <S.HeroNewsInner withBackground={withBackground} colorScheme={selectedColorScheme}>
          <Row $reverse={['xs', 'sm', 'md', 'lg' ]}>
            <Col xs={12} xl={6}  $justify={'center'}>
              <S.HeroNewsInfo>
                { date ? (
                  <S.HeroDate>
                    <Paragraph content={format(new Date(date), 'MMM d, yyyy', { locale })} />
                  </S.HeroDate>
                ) : null }
                { tags ? (
                  <S.HeroCategories>
                    {tags.map((tag, index) => (
                      <S.HeroCategory key={index} color={tag.colorScheme}>
                        <Paragraph content={tag.label} typo={'paragraphSM'} uppercase weight={'regular'} />
                      </S.HeroCategory>
                    ))}
                  </S.HeroCategories>
                ) : null }
              </S.HeroNewsInfo>
              { title ? (
                <>
                  <SpacerBase xs={3} />
                  <Heading content={title} as={'h1'} typo={'headingXXL'} />
                  <SpacerBase xs={3} />
                </>
              ) : null }
              { description ? (
                <Paragraph content={description} weight={'regular'} typo="headingSM" />
              ) : null }
            </Col>
            <Col xs={12} xl={6} $justify={'center'}>
              <S.MaskWrapper maskType={imageShape}>
                <Image
                  src={image.src}
                  alt={image.alt}
                  fill
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 100vw, 100vw"
                />
              </S.MaskWrapper>
            </Col>
          </Row>
        </S.HeroNewsInner>
      </Container>
    </S.HeroNews>
  )
}

export default HeroNews